module.exports = __webpack_public_path__ + "static/img/turntable-back.53fa5279.png";